import * as React from 'react';
import Footer from '../../components/footer/Footer';

import '../../assets/style.css';

import { participation_forms } from '../../data/participation_forms';
import { participation_additional } from '../../data/participation_forms';
import Section from '../../components/section/Section';
import Navbar from '../../components/nav/Navbar';
import {isBrowser, isMobile } from 'react-device-detect';

export default function ParticipationForms(){
    return (
        <>
        <Navbar/>
        <div className="background-opaque flex-column" style={{height:"100%", position:"relative"}}>
            <div className="flex-column centered" style={{paddingTop:"30vh", minHeight:"100vh", alignItems:"center"}}>
                <h1 style={{fontWeight:"400", fontSize:isMobile?"2rem":"3rem"}}>Oblici <span className="" >sudjelovanja</span></h1>
                <div style={{width:isMobile?"95%":"80%", position:"relative"}}>
                <div><h2 className='pillbox-huge button-huge hpd-green-background pillbox-like' style={{fontSize:isMobile?"1rem":"2rem",fontWeight:"400",  width:"90%"}}><span>Standardni oblici sudjelovanja</span></h2>
                {
                    participation_forms.map(({title, text}, index)=>{
                      return <Section key={index} style={{marginBottom:"3rem"}} className={"section-opaque section-overlay-transparent " + (index%2==0?"section-half-pillbox-top":"section-half-pillbox-bottom")} 
                      title={<div style={{width:"100%", textAlign:"right"}}><h2 className="pillbox-huge button-huge button-color-trans-dark pillbox-like" style={{fontSize:isMobile?"1.5rem":"2rem", fontWeight:"400"}}>{title}</h2></div>} content={
                        <div style={{padding:isMobile?"0 1rem 1rem 1rem":"0 7rem 7rem 7rem"}}>
                            <p style={{fontSize:isMobile?"calc(13px + .35vw) !important":"calc(13px + .35vw) !important", lineHeight:"1.5", textAlign:"left"}}>
                                {text}
                            </p>

                        </div>
                      }/>  
                    })
                }
            </div>
            
            <div><h2 className='pillbox-huge button-huge hpd-green-background pillbox-like' style={{fontSize:isMobile?"1rem":"2rem",fontWeight:"400", paddingLeft:"7rem", width:"90%"}}>Dodatne aktivnosti</h2>
                {
                    participation_additional.map(({title, text}, index)=>{
                        return <Section key={index} style={{marginBottom:"3rem"}} className={"section-opaque section-overlay-transparent " + (index%2==0?"section-half-pillbox-top":"section-half-pillbox-bottom")} title={<span><h2  className="pillbox-huge button-huge button-color-trans-dark pillbox-like" style={{margin:"0", fontSize:isMobile?"1.5rem":"2rem", fontWeight:"400"}}>{title}</h2></span>} content={
                        <div style={{padding:isMobile?"0 1rem 1rem 1rem":"0 7rem 7rem 7rem"}}>
                            <p style={{fontSize:isMobile?"calc(13px + .35vw) !important":"calc(13px + .35vw) !important", whiteSpace:"pre-line", lineHeight:"1.5", textAlign:"left"}}>
                                {text}
                            </p>

                        </div>
                      }/>  
                      })
                }
            
            </div>


            
            </div>
            </div>
        
        </div>
        <Footer/>
    
    </>

    )
}